import {projects_list_desinit} from "../projects/projects_list";
import {desinit_marques} from "../animations/marquee";
import {desinit_scroll_to_content} from "../animations/scrollToContentLink";
import {desinit_circle_square} from "../animations/circle_square";
import {project_single_desinit} from "../project-single/project.js";


const app_desinitialisation = (container) => {
   projects_list_desinit(container)
   desinit_marques(container)
   desinit_scroll_to_content(container)
   desinit_circle_square(container)
   project_single_desinit(container)
}

export default app_desinitialisation;
